import {DisclaimerType} from "../../definitions/types";
import {DisclaimerModel} from "../domain/disclaimerModel";

export class DisclaimersModel {
    private readonly _disclaimers: DisclaimerModel[];

    /**
     * @constructor
     * @param disclaimerTypes - The disclaimers to be modeled.
     * @description Creates a new instance of the DisclaimersModel class.
     */
    constructor(public readonly disclaimerTypes: DisclaimerType[]) {
        this._disclaimers = disclaimerTypes.map(disclaimer => new DisclaimerModel(disclaimer));
    }

    /**
     * @method disclaimers
     * @description Returns the disclaimers of the model as an array of DisclaimerModel instances.
     * @returns {DisclaimerModel[]}
     */
    public get disclaimers(): DisclaimerModel[] {
        return this._disclaimers;
    }
}